import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fileActions } from '../../store/actions'
import { useNavigate, useLocation } from 'react-router-dom'
import { groupActorsFunctions } from './GroupActorsFunctions.js'

//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './GroupActorsStyles.js'

import HelpIcon from '@mui/icons-material/Help';

import {
    CustomCounterAppBar, InputField,
    UseImage,
    CustomAlertHelpDialog,
    ListElement, CustomLoadingOverlay
    , Buttons
} from '../../components'

import {
    Typography,
    Button
    , useTheme
} from '@mui/material'

import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"
import { useTranslation } from 'react-i18next'

export default function CreateGroupComponent(props) {
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [openHelp, setOpenHelp] = useState(false)
    const [showName, setShowName] = useState(false)
    const [groupName, setGroupName] = useState('')
    const [actorOptions, setActorOptions] = useState([])
    const [currentActors, setCurrentActors] = useState([])

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    const file = useSelector(state => state.FileInfo)
    const auth = useSelector(state => state.Authentication)
    const actorsInfo = useSelector(state => state.Actors)
    const groupAnswer = useSelector(state => state.GroupName)
    const folioId = location.state.folioId
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(folioId))
        setLoadView(true)
    }, [])

    useEffect(() => {
        if (loadView && file.items != undefined) {
            if (file.items?.Stage != undefined && file.items?.Stage?.Properties.length > 0) {
                const optionsJson = file.items.Stage.Properties.find((prop) => prop.Name === 'ConfigurationOptions')
                setActorOptions(JSON.parse(optionsJson.Value))
                console.log(JSON.parse(optionsJson.Value))
                dispatch(fileActions.GetActors(folioId))
            }
        }
    }, [file])

    useEffect(() => {
        if (loadView && actorsInfo.items != undefined) {
            if (actorsInfo.items.length > 0) {
                const nextComponent = 'GroupActorsComponent'
                groupActorsFunctions.nextStage({ auth, navigate, nextComponent, folioId })
            } else {
                setLoadView(false)
            }
        }
    }, [actorsInfo])

    const addActor = (name) => {
        const selected = actorOptions.find((option) => option.TypeName === name)
        const newOptions = actorOptions.filter((option) => option.TypeName != name)
        console.log('opcions', selected, newOptions)
        setCurrentActors([...currentActors, selected])
        if (selected.MaximumNumberAllowed === -1) {
            setActorOptions([...newOptions, selected])
        } else {
            setActorOptions(newOptions)
        }
    }

    const deleteActor = (name) => {
        const selected = currentActors.find((option) => option.TypeName === name)
        const newOptions = currentActors.filter((option) => option.TypeName != name)
        setCurrentActors(newOptions)
        if (selected.MaximumNumberAllowed != -1) {
            setActorOptions([...actorOptions, selected])
        }
    }

    const createActors = async (arrayList) => {
        const iteracy = arrayList.map(async (data) => {
            return await groupActorsFunctions.docRequest(data)
        })
        return await Promise.all(iteracy)
    }

    const createNewGroup = () => {
        const namedGroup = {
            File_Id: folioId,
            GroupName: groupName
        }
        setLoadView(true)
        console.log(namedGroup)
        dispatch(fileActions.SetGroupName(namedGroup))
    }

    useEffect(() => {
        if (loadView && groupAnswer.items != undefined) {
            const createBody = currentActors.map((item) => {
                return {
                    File_Id: folioId,
                    TypeName: item.TypeName
                }
            })

            createActors(createBody).then((response) => {
                setLoadView(false)
                console.log('response setgroup actors', response)
                const nextComponent = 'GroupActorsComponent'
                groupActorsFunctions.nextStage({ auth, navigate, nextComponent, folioId })
            })
        }
    }, [groupAnswer])

    const newGroupInstructions = 'Para abrir un grupo en necesario agregar al menos un integrante. Elige el tipo de rol que deseas agregar.'

    let list = [
        {
            key: 'firstStep',
            component: <WizardComponent
                title='Iniciar proceso de integrante'
                description='Recuerda que puedes editar el proceso de un usuario previamente registrado, para iniciar o completar el registro haz clic sobre el rol a editar.'
                image='Iniciar_proceso.gif' />
        },
        {
            key: 'secondStep',
            component: <WizardComponent
                title='Enviar solicitud'
                description='Para enviar una solicitud, primero debes completar la carga de documentos por rol, y estos debe ser validados para continuar.'
                image='Enviar_solicitud.gif' />
        },
        {
            key: 'thirdStep',
            component: <WizardComponent
                title='Eliminar integrante'
                description='Para eliminar deberás acceder a "Editar Roles" y eliminar al integrante. Te recordamos que esta acción no se podrá revertir.'
                image='Cancelar_solicitud.gif' />
        }
    ]

    return (
        <div className={gridContainer.container}>
            <div className={gridContainer.leftColumn}></div>
            <div className={gridContainer.centerColumn}>
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                {/* {loadView ? <LoadingOverlay
                    active={loadView}
                    spinner
                    text='Espere un momento por favor...'
                    className={classes.loader}>
                </LoadingOverlay> : null} */}
                <CustomCounterAppBar />
                <div className={gridContainer.centerContent1}>
                    {!showName &&
                        <div className={localStyles.titleSection}>
                            <Typography variant='h6'><b>Crear nuevo grupo</b></Typography>
                            <HelpIcon style={{ marginLeft: 7 }} onClick={() => { setOpenHelp(true) }} />
                        </div>}

                    {!showName && <InputField
                        fullWidth
                        size="small"
                        type='Text'
                        textTransform='none'
                        value={groupName}
                        variant='outlined'
                        onBlur={() => { setShowName(true) }}
                        className={localStyles.nameInput}
                        onChange={(e) => { setGroupName(e.target.value) }}
                        label='Nombre de grupo' />}

                    {showName && <div className={localStyles.titleSection}>
                        <Typography variant='h6' onClick={() => setShowName(false)}><b>{groupName != '' ? groupName : 'Sin nombre de grupo'}</b></Typography>
                        <HelpIcon style={{ marginLeft: 7 }} onClick={() => { setOpenHelp(true) }} />
                    </div>}


                    <Typography variant='subtitle1' className={localStyles.instructions}>{newGroupInstructions}</Typography>
                    <div className={localStyles.actorsContainer}>
                        <div className={localStyles.actorsSections}>
                            {currentActors.map((actor) => {
                                return <Button
                                    className={gridContainer.buttonListNoHover}
                                    key={actor.Name}
                                    onClick={() => deleteActor(actor.TypeName)}
                                >
                                    <ListElement
                                        text={actor.TypeName}
                                        icon={actor.Icon}
                                        noArrow={true}
                                        status='Eliminar'
                                        statusColor={4}
                                        delete={true}
                                    />
                                </Button>
                            })}
                        </div>

                        <div className={localStyles.newActorsSections}>
                            {actorOptions.map((option) => {
                                return <Button
                                    className={gridContainer.buttonList}
                                    key={option.TypeName}
                                    onClick={() => { addActor(option.TypeName) }}
                                >
                                    <ListElement
                                        text={`Agregar nuevo ${option.TypeName}`}
                                        icon={option.Icon}
                                        newItem={true}
                                    />
                                </Button>
                            })}
                        </div>

                    </div>

                    {groupName != '' && currentActors.length > 0 &&
                        <Buttons
                            text_color="#FFFFFF"
                            background_color={theme.palette.primary.main}
                            border_color={theme.palette.primary.main}
                            text="Crear grupo"
                            type="button"
                            click={createNewGroup}
                        />}

                </div>

                <CustomAlertHelpDialog
                    closeAction={() => { setOpenHelp(false) }}
                    open={openHelp}
                    body={
                        <div ref={ref} className={localStyles.containerHelp}>
                            {list.map(item => (
                                <div key={item.key}>{item.component}</div>
                            ))}
                        </div>
                    }
                />

            </div>
            <div className={gridContainer.rightColumn}></div>
        </div>
    )

}

function WizardComponent(props) {
    const localStyles = {}//useStyles()

    return (
        <div className={localStyles.insideHelpContent}>
            <Typography
                variant="h6"
                gutterBottom
                className={localStyles.wizardTitle}>
                {props.title}
            </Typography>
            <Typography
                variant="subtitle1"
                gutterBottom
                className={localStyles.wizardSubtitle}>
                {props.description}
            </Typography>
            <UseImage className={localStyles.wizardImg} src={props.image} />
        </div>
    )
}